import React, { Component } from "react";
import PropTypes from "prop-types";
import { Parent } from "pym.js";

import CardWrapper from "cards/components/CardWrapper";
import styles from "./AxiosVisualsStreamCap.css";
import { promoInViewDataLayerEvent } from "utils/analytics";

class AxiosVisualsStreamCap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isClient: false,
    };
  }

  componentDidMount() {
    this.setState({ isClient: true });
    promoInViewDataLayerEvent("stream_cap_axios_visuals", {
      link: this.state.url,
    });
  }

  componentDidUpdate() {
    if (!this.state.pymParent && this.state.isClient) {
      const pymParent = new Parent(this.state.id, this.state.url);
      this.setState({ pymParent });
    }
  }

  static getDerivedStateFromProps(props) {
    return {
      id: `av-cap-${props.slug}`,
      url: `https://graphics.axios.com/${props.slug}/index.html`,
    };
  }

  getAxiosVisualHtml(id) {
    return `
        <div id="${id}" style="max-width:100%;"></div>
      `;
  }

  render() {
    return (
      <CardWrapper className="gtm-stream-cap-axios-visuals">
        <figure className={styles.figure}>
          <div
            dangerouslySetInnerHTML={{
              __html: this.state.isClient
                ? this.getAxiosVisualHtml(this.state.id)
                : "",
            }}
          />
        </figure>
      </CardWrapper>
    );
  }
}

AxiosVisualsStreamCap.propTypes = {
  slug: PropTypes.string,
};

export default AxiosVisualsStreamCap;
